<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="clockInRecordDialogVisible"
        :append-to-body="true"
        class="custom_form_dialog custom-form-dialog clock_record_select_dialog"
        title="打卡记录"
        width="900px"
    >
        <div v-loading="loading" class="custom_form_body">
            <div class="page-filter_wrap">
                <div class="page-filter_wrap_left">
                    <el-input
                        ref="order_search_input"
                        v-model="searchForm.keyword"
                        class="filter-input"
                        clearable
                        placeholder="请搜索打卡地址"
                        @blur="handleClickSearch"
                        @clear="handleClickSearch"
                        @keyup.enter.native="handleClickSearch"
                    >
                        <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                    </el-input>
                    <el-date-picker
                        :picker-options="pickerOptions"
                        @change="handleClickSearch"
                        align="right"
                        size="small"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        range-separator="-"
                        start-placeholder="开始日期"
                        type="daterange"
                        unlink-panels
                        v-model="searchForm.calc_date"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </div>
            </div>
            <el-table
                class="custom_table"
                :data="clockRecordData"
                border
                height="300px"
                :max-height="590"
                ref="detailsTable"
                @selection-change="handleSelectionChange"
                @select="handleSelect"
            >
                <el-table-column type="selection" width="50"> </el-table-column>
                <el-table-column label="打卡时间" prop="" width="380">
                    <template slot-scope="{ row }">
                        <span v-if="row.punch_type == 'SINGLE'">{{ row.created_at }}</span>
                        <span v-else>{{ row.start_time  }}~{{ row.end_time }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="打卡地址" prop="" width="336" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span>{{ row.address }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="打卡详情" prop="" width="84">
                    <template slot-scope="{ row }">
                        <span class="link-label" @click="handleClickDetail(row)">详情</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                size="mini"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.pageNum"
                :page-sizes="pagination.pageSizes"
                :page-size="pagination.pageSize"
                :layout="pagination.layout"
                :pager-count="5"
                :total="pagination.total"
            >
            </el-pagination>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
        <el-drawer
            size="520px"
            :append-to-body="true"
            direction="rtl"
            class="custom_drawer custom_clockIn_detail_drawer"
            :visible.sync="detailVisible"
            :withHeader="false"
            :close-on-press-escape="false"
            :before-close="handleDrawerClose"
        >
            <div class="drawer_wrap">
                <div class="drawer_header">
                    <h3 class="title" v-text="'打卡详情'"></h3>
                    <span class="handle_icon_wrap" @click="handleDrawerClose">
                        <i class="el-icon-close"></i>
                    </span>
                </div>
                <div class="drawer_body" v-loading="loading">
                    <ul class="detail_list">
                        <li class="detail_list_item" v-for="(item, index) in detailRecordList">
                            <p v-if="index == 0" class="item_title">
                                {{ detailRecordList.length > 1 ? "开始时间" : "打卡时间" }}
                            </p>
                            <p
                                v-else-if="index === detailRecordList.length - 1 && detailRecordList.length > 1"
                                class="item_title"
                            >
                                结束时间{{ item.is_skip == 1 ? "（无需打卡）" : "" }}
                            </p>
                            <p v-else></p>
                            <template v-if="!item.is_skip">
                                <div class="list_time"><i class="iconfont icon-shijian"></i>{{ item.punch_at }}</div>
                                <div><i class="iconfont icon-weizhi1"></i>{{ item.location }}</div>
                                <div v-if="item.images && item.images.length">
                                    <ul class="voucher_list">
                                        <li :key="imgIndex" class="voucher_item" v-for="(img, imgIndex) in item.images">
                                            <el-image
                                                :preview-src-list="item.images"
                                                :src="img"
                                                alt=""
                                                style="max-width: 44px; max-height: 44px"
                                            ></el-image>
                                        </li>
                                    </ul>
                                </div>
                                <div>{{ item.remark }}</div>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
        </el-drawer>
    </el-dialog>
</template>

<script>
import { GetRelatecheckRecord } from "@/api";
import { pagination } from "@/mixins";
export default {
    name: "ClockInRecordSelect",
    props: {
        clockInRecordDialogVisible: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            loading: false,
            searchForm: {
                keyword: "",
                calc_date: [],
            },
            selectedRow: null, // 存储当前选中行
            clockRecordData: [],
            detailVisible: false,
            detailRecordList: [], // 打卡详情数据
            pickerOptions: {
                shortcuts: [
                    {
                        text: "本月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(end.getFullYear(), end.getMonth(), 1);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const start = new Date();
                            start.setMonth(Math.floor(start.getMonth() / 3) * 3, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(start);
                            end.setMonth(start.getMonth() + 3, 0);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本年",
                        onClick(picker) {
                            const start = new Date(new Date().getFullYear(), 0, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(new Date().getFullYear(), 11, 31);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    mixins: [pagination],
    created() {
        this.getRelatecheckRecordData()
    },
    methods: {
        // 弹框关闭
        handleDialogClose() {
            this.$emit("update:clockInRecordDialogVisible", false);
        },
        // 处理选中事件
        handleSelect(selection, row) {
            if (selection.length > 1) {
                this.$refs.detailsTable.clearSelection(); // 清空所有选择
                this.$refs.detailsTable.toggleRowSelection(row); // 重新选中当前行
            }
        },
        // 选中状态变化
        handleSelectionChange(selection) {
            this.selectedRow = selection.length ? selection[0] : null;
        },
        // 确认选择的数据
        handleDialogConfirm() {
            if(!this.selectedRow) return this.$message.error("请选择一条打卡记录")
            this.$emit("selectClockIndata", this.selectedRow)
            console.log(this.selectedRow)
        },
        handleClickSearch() {
            this.handleCurrentChange(1)
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getRelatecheckRecordData()
        },
        // 获取打卡记录
        getRelatecheckRecordData() {
            this.loading = true
            const params = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                check_in_date: this.searchForm.calc_date
            }
            GetRelatecheckRecord(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.clockRecordData = data || [];
                    this.pagination.total = total
                }
                this.loading = false
            }).catch(()=> {
                this.loading = false
            })
        },
        // 查看某条数据的打卡详情明细
        handleClickDetail(row) {
            let detailRecordList = [];
            if (row.punch_type == "SINGLE") {
                detailRecordList.push({punch_type: row.punch_type, punch_at: row.start_time,  is_skip: row.is_skip, location: row.address.split("、")[0]});
            } else {
                detailRecordList = [
                    { punch_type: row.punch_type, punch_at: row.start_time,  is_skip: row.is_skip, location: row.address.split("、")[0]},
                    { punch_type: row.punch_type, punch_at: row.end_time,  is_skip: row.is_skip, location: row.end_time ? (row.address.split("、")[1] || row.address.split("、")[0]) : "" },
                ];
            }
            this.detailRecordList = detailRecordList;
            this.detailVisible = true;
        },
        // 打卡详情关闭
        handleDrawerClose() {
            this.detailVisible = false;
        },
    },
};
</script>

<style lang="scss">
.clock_record_select_dialog {
    .page-filter_wrap {
        margin-bottom: 16px;
    }
}
.custom_table {
    ::v-deep thead {
        th {
            font-weight: 400;
        }
        .cell {
            font-weight: 400 !important;
        }
    }
}
.custom_clockIn_detail_drawer {
    .drawer_wrap {
        .drawer_header {
            box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.08);
        }
        .drawer_body {
            background-color: #ffffff;
            .detail_list {
                padding: 20px 16px;
                .detail_list_item {
                    width: 100%;
                    padding-left: 10px;
                    padding-bottom: 16px;
                    box-sizing: border-box;
                    position: relative;
                    &::before {
                        width: 6px;
                        height: 6px;
                        opacity: 1;
                        border-radius: 50%;
                        content: " ";
                        left: 0;
                        top: 6px;
                        position: absolute;
                        background: rgba(41, 144, 255, 1);
                        z-index: 10;
                    }
                    &::after {
                        width: 1px;
                        height: 100%;
                        position: absolute;
                        left: 2.5px;
                        top: 6px;
                        background-color: rgba(0, 0, 0, 0.08);
                        content: " ";
                    }
                    .item_title {
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 18px;
                        color: rgba(153, 153, 153, 1);
                        margin-bottom: 12px;
                    }
                    .iconfont {
                        font-size: 14px;
                        color: rgba(102, 102, 102, 1);
                        margin-right: 4px;
                    }
                    & > div {
                        & + div {
                            margin-top: 8px;
                        }
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(102, 102, 102, 1);
                    }
                    .list_time {
                        font-weight: 700;
                        color: rgba(51, 51, 51, 1);
                    }
                }
            }
            .voucher_list {
                display: flex;
                gap: 8px;
                .voucher_item {
                    width: 44px;
                    height: 44px;
                    cursor: pointer;
                    position: relative;
                    text-align: center;
                    border-radius: 4px;
                    img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: cover;
                    }
                }
            }
        }
    }
}
</style>
